interface StatCardsProps {
  theme: any;
  radius: number;
  stats: Array<{ key: string; value: string }>;
}

export default function StatCards({ theme, radius, stats }: StatCardsProps) {
  if (!stats || stats.length === 0) return null;

  // Determine grid layout based on number of stats
  const getGridClasses = (count: number) => {
    if (count === 1) return "grid-cols-1 max-w-sm";
    if (count === 2) return "grid-cols-1 sm:grid-cols-2 max-w-2xl";
    if (count === 3) return "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 max-w-3xl";
    return "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 max-w-4xl";
  };

  return (
    <div className={`grid gap-4 mx-auto ${getGridClasses(stats.length)}`}>
      {stats.map((stat, index) => (
        <div 
          key={index} 
          className="p-5 shadow-sm transition-all duration-200 hover:shadow-md"
          style={{
            borderRadius: radius,
            border: `1px solid ${theme.borderHover}`,
            background: theme.card
          }}
        >
          <div className="text-2xl font-bold font-secondary" style={{ color: theme.text }}>
            {stat.key}
          </div>
          <div className="text-sm tracking-wide font-secondary" style={{ color: theme.subtleText }}>
            {stat.value}
          </div>
        </div>
      ))}
    </div>
  );
}
